import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { WINDOW } from '@pin-up-global/common';

export const redirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const window = inject(WINDOW);
  const { hostname: currentHost, origin } = window.location;
  const { url: urlToRedirect } = route.queryParams;

  try {
    const url = new URL(urlToRedirect, origin);

    const { hostname: targetHost } = url;

    if (targetHost === currentHost || targetHost.includes(currentHost)) {
      window.location.href = url.toString();
      return false;
    } else {
      return router.parseUrl('/');
    }
  } catch {
    return router.parseUrl('/');
  }
};
